import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ExpandablePartyListComponent } from "./expandable-party-table.component";
import { TranslateModule } from "@ngx-translate/core";
import { BarChartRendererModule } from '../table/renderers/bar-chart-renderer/bar-chart-renderer.module';
import { ResponsiveCompactRendererModule } from '@valg-shared/components/table/renderers/compact-renderer/responsive-compact-renderer.module';
import { PositiveNegativeRendererModule } from '@valg-shared/components/table/renderers/positive-negative-renderer/positive-negative-renderer.module';
import { TableModule } from '@valg-shared/components/table/table.module';
import { BarChartModule } from '../bar-chart/bar-chart.module';
import { ResultSummaryModule } from '../result-summary/result-summary.module';
import { SimpleResultSummaryModule } from '../simple-result-summary/simple-result-summary.module';
@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,
        BarChartRendererModule,
        TableModule,
        BarChartModule,
        ResponsiveCompactRendererModule,
        PositiveNegativeRendererModule,
        ResultSummaryModule,
        SimpleResultSummaryModule
    ],
  declarations: [
    ExpandablePartyListComponent
  ],
  exports: [
    ExpandablePartyListComponent
  ]
})
export class ExpandablePartyTableModule {}
